import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["note", "noteContainer", "noteTemplate"]

  connect() {
    console.log("InvoiceNotesController connected")
  }

  addNote(event) {
    event.preventDefault();
    const content = this.noteTemplateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.noteContainerTarget.insertAdjacentHTML('beforeend', content);
  }

  removeNote(event) {
    event.preventDefault();
    const note = event.target.closest('[data-invoice-notes-target="note"]');
    if (note) {
      note.remove();
    }
  }
} 
